import { Component, OnInit, Input } from "@angular/core";
import { LoadContact, TransportationLoad } from "../../../../transportation/transportation";
import { IconProgressStep } from "../../../../rubbl-shared/rubbl-shared";

@Component({
  selector: "common-fulfillment-item-transportation-card",
  templateUrl: "./fulfillment-item-transportation-card.component.html",
})
export class FulfillmentItemTransportationCardComponent implements OnInit {
  @Input() showNotificationData: boolean = false;
  @Input() transportationLoad: TransportationLoad;
  @Input() showDropOffInfo: boolean = true;

  quotedStep: IconProgressStep = { label: "Quoted", iconClass: "icon-quote", active: false, completed: false };
  scheduleStep: IconProgressStep = { label: "Scheduled", iconClass: "icon-clipboard-fill", active: false, completed: false };
  inTransitStep: IconProgressStep = { label: "In Transit", iconClass: "icon-truck-fill", active: false, completed: false };
  arrivingSoonStep: IconProgressStep = { label: "Arriving Soon", iconClass: "icon-clock-fill", active: false, completed: false };
  arrivedStep: IconProgressStep = { label: "Delivered", iconClass: "icon-delivered", active: false, completed: false };

  steps: IconProgressStep[] = [this.quotedStep, this.scheduleStep, this.inTransitStep, this.arrivingSoonStep, this.arrivedStep];

  notificationTitle = {
    Requested: "A transportation quote has been requested for your machine.",
    Quoted: "Transportation has been quoted.",
    Scheduled: "Transportation has been scheduled.",
    InTransit: "Your machine is on its way to the dropoff location.",
    ArrivingSoon: "Your machine is within 50 miles of the dropoff location and will be arriving soon.",
    Arrived: "Your machine has been delivered to the dropoff location.",
  };

  notificationDate = null;

  constructor() {}

  ngOnInit(): void {
    // we are temporarily setting this carrier to always be Teddy boy
    this.transportationLoad.carrier = {
      name: "Ted Boldster, ABBA Freight Systems ",
      phoneNumber: "(541) 630-3468",
      email: "tedb@abbafreight.net",
    } as LoadContact;

    // not using breaks for follow through
    switch (this.transportationLoad.status) {
      case "Delivered":
        this.arrivedStep.active = true;
        this.arrivingSoonStep.completed = true;

      case "Arrived":
        this.arrivedStep.active = true;
        this.arrivingSoonStep.completed = true;

      case "ArrivingSoon":
        this.inTransitStep.completed = true;
        this.arrivingSoonStep.active = true;

      case "InTransit":
        this.scheduleStep.completed = true;
        this.inTransitStep.active = true;

      case "Scheduled":
        this.quotedStep.completed = true;
        this.scheduleStep.active = true;
        break;

      case "Quoted":
        this.quotedStep.active = true;
        break;

      case "Requested":
        break;
    }
  }
}
